// ============================================================================
// JOB SEQUENCING - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'job-sequencing',
  name: 'Job Sequencing',
  category: 'Greedy',
  complexity: {
    time: 'O(n^2)',
    space: 'O(n)'
  },
  description: 'Job Sequencing selects maximum jobs within deadlines using greedy approach. Sorts by profit descending and schedules at latest available slot before deadline.'
};
export type MetaType = typeof meta;
